import { Button } from "../../components/Button";

const eventKindLabel = (kind) => (kind === "tournament" ? "Турнир" : "Мероприятие");

export function AdminEventsSection({
  eventDraft,
  setEventDraft,
  uploadingEventImage,
  onEventImageChange,
  onEventSubmit,
  loading,
  events,
  togglePublished,
  removeEvent,
  tournamentGuestSearchByEventId,
  tournamentGuestCandidatesByEventId,
  loadingTournamentGuestSearchEventId,
  savingTournamentParticipantsEventId,
  onTournamentGuestSearchChange,
  addTournamentParticipant,
  removeTournamentParticipant,
  toggleTournamentParticipantsOpen,
  openedTournamentParticipantsEventId,
  seedTournament,
  pickTournamentWinner,
  refreshTournament,
}) {
  const addLabel = eventDraft.kind === "tournament" ? "турнир" : "мероприятие";
  const renderMatch = (item, match) => {
    const p1 = match?.player1;
    const p2 = match?.player2;
    const isDone = match?.status === "completed" || match?.status === "bye";
    const winnerName =
      Number(match?.winner_user_id) === Number(p1?.user_id)
        ? p1?.full_name
        : Number(match?.winner_user_id) === Number(p2?.user_id)
          ? p2?.full_name
          : null;
    return (
      <div key={match.id} className="tournamentMatchCard">
        <p className="muted tournamentMatchCard__title">Матч {match.id}</p>
        <p className="muted tournamentMatchCard__players">
          {p1?.full_name || "TBD"} vs {p2?.full_name || "TBD"}
        </p>
        {isDone ? (
          <p className="muted">
            Победитель: {winnerName || "определён"}
          </p>
        ) : null}
        {!isDone ? (
          <div className="tournamentMatchCard__actions">
            {p1 ? (
              <Button type="button" onClick={() => pickTournamentWinner(item, match.id, p1.user_id)}>
                Победил: {p1.full_name}
              </Button>
            ) : null}
            {p2 ? (
              <Button type="button" onClick={() => pickTournamentWinner(item, match.id, p2.user_id)}>
                Победил: {p2.full_name}
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  };

  const tournamentUserNameById = (item, userId) => {
    const id = Number(userId || 0);
    if (!id) return "—";
    const participant = (item?.tournament_participants || []).find(
      (p) => Number(p?.user_id) === id,
    );
    if (!participant) return "—";
    return participant.full_name || "—";
  };

  return (
    <>
      <form className="adminForm" onSubmit={onEventSubmit}>
        <h3>Добавить запись</h3>
        <label className="field">
          Тип
          <select
            value={eventDraft.kind}
            onChange={(e) =>
              setEventDraft((prev) => ({ ...prev, kind: e.target.value }))
            }
          >
            <option value="event">Мероприятие</option>
            <option value="tournament">Турнир</option>
          </select>
        </label>
        <label className="field">
          Заголовок
          <input
            type="text"
            placeholder="Например, DJ Night в пятницу"
            value={eventDraft.title}
            onChange={(e) => setEventDraft((prev) => ({ ...prev, title: e.target.value }))}
          />
        </label>
        <label className="field">
          Дата
          <input
            type="date"
            value={eventDraft.date}
            onChange={(e) => setEventDraft((prev) => ({ ...prev, date: e.target.value }))}
          />
        </label>
        <label className="field">
          Время
          <input
            type="time"
            value={eventDraft.time}
            onChange={(e) => setEventDraft((prev) => ({ ...prev, time: e.target.value }))}
          />
        </label>
        <label className="field">
          Описание мероприятия
          <textarea
            rows="4"
            placeholder="Короткое описание для гостей"
            value={eventDraft.description}
            onChange={(e) =>
              setEventDraft((prev) => ({ ...prev, description: e.target.value }))
            }
          />
        </label>
        {eventDraft.kind !== "tournament" ? (
          <>
            <label className="field">
              Фото мероприятия
              <input type="file" accept="image/*" onChange={onEventImageChange} />
            </label>
            {uploadingEventImage ? <p className="muted">Загрузка изображения...</p> : null}
            {eventDraft.image_url ? (
              <div className="adminImagePreview">
                <img src={eventDraft.image_url} alt="Превью мероприятия" />
              </div>
            ) : null}
          </>
        ) : null}
        <label className="field field--inline">
          <input
            type="checkbox"
            checked={eventDraft.is_published}
            onChange={(e) =>
              setEventDraft((prev) => ({ ...prev, is_published: e.target.checked }))
            }
          />
          Опубликовать сразу
        </label>
        <Button type="submit" variant="accent">
          Добавить {addLabel}
        </Button>
      </form>

      <section className="adminGroup">
        <h3>Мероприятия</h3>
        {loading ? <p className="muted">Загрузка...</p> : null}
        {!loading && events.length === 0 ? <p className="muted">Пока нет записей.</p> : null}
        {!loading
          ? events.map((item) => (
            <article key={item.id} className="adminItem adminItem--stack">
                <div className="adminItem">
                  <div>
                  <h4>{item.title}</h4>
                  <p>
                    {item.date} · {item.time}
                  </p>
                  <p>{item.description}</p>
                  {item.image_url ? (
                    <div className="adminImagePreview adminImagePreview--small">
                      <img src={item.image_url} alt={item.title} />
                    </div>
                  ) : null}
                  <p className="muted">
                    Тип: {eventKindLabel(item.kind)}
                  </p>
                  <p className="muted">
                    Статус: {item.is_published ? "опубликовано" : "черновик"}
                  </p>
                  </div>
                  <div className="adminItemActions">
                    <Button type="button" onClick={() => togglePublished(item)}>
                      {item.is_published ? "Снять с публикации" : "Опубликовать"}
                    </Button>
                    <Button type="button" onClick={() => removeEvent(item)}>
                      Удалить
                    </Button>
                  </div>
                </div>
                {item.kind === "tournament" ? (
                  <div className="adminGroup">
                    <Button
                      type="button"
                      onClick={() => toggleTournamentParticipantsOpen(item)}
                    >
                      {openedTournamentParticipantsEventId === item.id
                        ? "Скрыть участников"
                        : `Участники турнира (${(item.tournament_participants || []).length})`}
                    </Button>
                    {openedTournamentParticipantsEventId === item.id ? (
                      <>
                        <div className="adminItemActions">
                          <Button type="button" onClick={() => seedTournament(item)}>
                            Распределить участников
                          </Button>
                          <Button type="button" onClick={() => refreshTournament(item)}>
                            Обновить сетку
                          </Button>
                        </div>
                        {item.tournament_bracket ? (
                          <div className="tournamentBracket">
                            <p className="muted">Статус сетки: {item.tournament_bracket.status}</p>
                            <div className="tournamentBracket__columns">
                              {Array.isArray(item.tournament_bracket.winner_rounds) &&
                              item.tournament_bracket.winner_rounds.length > 0 ? (
                                <div className="tournamentBracket__column">
                                  <h4>Верхняя сетка</h4>
                                  {item.tournament_bracket.winner_rounds.map((round) => (
                                    <div key={`W_${round.round_index}`} className="tournamentBracket__round">
                                      <p className="muted">Раунд W{round.round_index}</p>
                                      {(round.matches || []).map((m) => renderMatch(item, m))}
                                    </div>
                                  ))}
                                </div>
                              ) : null}
                              {Array.isArray(item.tournament_bracket.loser_rounds) &&
                              item.tournament_bracket.loser_rounds.length > 0 ? (
                                <div className="tournamentBracket__column">
                                  <h4>Нижняя сетка</h4>
                                  {item.tournament_bracket.loser_rounds
                                    .filter((r) => Number(r.round_index) > 0)
                                    .map((round) => (
                                      <div key={`L_${round.round_index}`} className="tournamentBracket__round">
                                        <p className="muted">Раунд L{round.round_index}</p>
                                        {(round.matches || []).map((m) => renderMatch(item, m))}
                                      </div>
                                    ))}
                                </div>
                              ) : null}
                              <div className="tournamentBracket__column">
                                <h4>Финалы</h4>
                                {item.tournament_bracket.grand_final ? (
                                  <div className="tournamentBracket__round">
                                    <p className="muted">Гранд-финал</p>
                                    {renderMatch(item, item.tournament_bracket.grand_final)}
                                  </div>
                                ) : (
                                  <p className="muted">Гранд-финал еще не сформирован.</p>
                                )}
                                {item.tournament_bracket.third_place ? (
                                  <div className="tournamentBracket__round">
                                    <p className="muted">Матч за 3 место</p>
                                    {renderMatch(item, item.tournament_bracket.third_place)}
                                  </div>
                                ) : (
                                  <p className="muted">Матч за 3 место еще не сформирован.</p>
                                )}
                              </div>
                            </div>
                            {item.tournament_bracket.first_place_user_id ? (
                              <p className="muted">
                                Итог: 1 место {tournamentUserNameById(
                                  item,
                                  item.tournament_bracket.first_place_user_id,
                                )}
                                , 2 место{" "}
                                {tournamentUserNameById(
                                  item,
                                  item.tournament_bracket.second_place_user_id,
                                )}
                                , 3 место{" "}
                                {tournamentUserNameById(
                                  item,
                                  item.tournament_bracket.third_place_user_id,
                                )}
                              </p>
                            ) : null}
                          </div>
                        ) : null}
                        {(item.tournament_participants || []).length > 0 ? (
                          <div className="adminItem adminItem--stack">
                            <h4>Уже участвуют</h4>
                            {(item.tournament_participants || []).map((p) => (
                              <div key={`${item.id}:${p.user_id}`} className="adminItemActions">
                                <p className="muted">
                                  {p.full_name} · Telegram id {p.telegram_id}
                                </p>
                                <Button
                                  type="button"
                                  disabled={savingTournamentParticipantsEventId === item.id}
                                  onClick={() =>
                                    removeTournamentParticipant(item, Number(p.user_id))
                                  }
                                >
                                  Удалить из турнира
                                </Button>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="muted">Участников пока нет.</p>
                        )}
                        <label className="field">
                          Поиск гостя в базе
                          <input
                            type="search"
                            placeholder="Фамилия, имя, ник, username или Telegram id"
                            value={tournamentGuestSearchByEventId?.[item.id] || ""}
                            onChange={(e) =>
                              onTournamentGuestSearchChange(item.id, e.target.value)
                            }
                          />
                        </label>
                        {loadingTournamentGuestSearchEventId === item.id ? (
                          <p className="muted">Поиск гостей...</p>
                        ) : null}
                        {Array.isArray(tournamentGuestCandidatesByEventId?.[item.id]) &&
                        tournamentGuestCandidatesByEventId[item.id].length > 0 ? (
                          <div className="adminItem adminItem--stack">
                            <h4>Добавить из базы гостей</h4>
                            {tournamentGuestCandidatesByEventId[item.id].map((row) => {
                              const exists = (item.tournament_participants || []).some(
                                (x) => Number(x?.user_id) === Number(row.id),
                              );
                              const label = [
                                row.profile_last_name,
                                row.profile_first_name,
                                row.profile_patronymic,
                              ]
                                .filter(Boolean)
                                .join(" ")
                                .trim();
                              return (
                                <div key={row.id} className="adminItemActions">
                                  <p className="muted">
                                    {label || row.profile_nickname || row.username || "Без имени"} ·
                                    Telegram id {row.telegram_id}
                                  </p>
                                  <Button
                                    type="button"
                                    disabled={exists || savingTournamentParticipantsEventId === item.id}
                                    onClick={() => addTournamentParticipant(item, row)}
                                  >
                                    {exists ? "Уже в списке" : "Добавить"}
                                  </Button>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <p className="muted">Ничего не найдено по фильтру.</p>
                        )}
                      </>
                    ) : null}
                  </div>
                ) : null}
              </article>
            ))
          : null}
      </section>
    </>
  );
}

